// header 語言切換按鈕
import { useDispatch } from 'react-redux';
import { setShowLanguageModal } from '@/slices/popSlice';

const HeaderToggleLanguage = () => {
    const dispatch = useDispatch();

    return (
        <button
            onClick={() => dispatch(setShowLanguageModal(true))}
            className="w-[32px] h-[32px] rounded-[50%] center-center border-1 border-[rgba(170,130,195,0.32)] trans
            hover:bg-bou hover:border-bou group ulg:hidden"
        >
            <span
                className="w-[18px] h-[18px] bg-contain bg-center trans group-hover:filter-white
                bg-[url('/images/icon/icon_language.svg')]"
            />
        </button>
    );
};

export default HeaderToggleLanguage;
